<template>
  <div>
    <div>
      <button class="button is-success" @click="lauchCreate()">
        Ajouter un tag
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Nom</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tag in tags" :key="tag.id">
          <td>{{ tag.name }}</td>
          <td>
            <button
              class="button is-warning update-button"
              @click="lauchUpdate(tag.id)"
            >
              <div class="icon">
                <img
                  src="@/assets/icons/pen-to-square-solid.svg"
                  alt="icone de crayon"
                />
              </div>
            </button>

            <button class="button is-danger" @click="lauchDelete(tag.id)">
              <div class="icon">
                <img
                  src="@/assets/icons/trash-can-solid.svg"
                  alt="icon de poubelle"
                />
              </div>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="modal" v-bind:class="{ 'is-active': isActiveModalUpdate }">
      <div class="modal-background" @click="close"></div>

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="tagName != null">
            {{ tagName }}
          </p>
          <p class="modal-card-title" v-if="tagName == null">Ajouter un tag</p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-12-desktop">
              <form @submit.prevent="submitForm" class="box">
                <div class="field">
                  <label class="label">Nom</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      placeholder="Nom"
                      v-model="name"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <div class="notification is-danger is-light" v-if="is_failure">
          {{ error_messsage }}
        </div>
        <footer class="modal-card-foot">
          <button
            class="button is-success"
            v-if="is_create == true"
            @click="add()"
          >
            Ajouter ce tag
          </button>
          <button
            class="button is-warning"
            v-if="is_create == false"
            @click="update(id)"
          >
            Confirmer les modifications
          </button>

          <button class="button" @click="close">Annuler</button>
        </footer>
      </div>
    </div>
    <div class="modal" v-bind:class="{ 'is-active': isActiveModalDelete }">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="tagActif.name != null">
            {{ tagActif.name }}
          </p>
          <p class="modal-card-title" v-if="tagActif.name == null">
            Ajouter un tag
          </p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <h1>Êtes-vous certains de vouloir supprimer ce tag ?</h1>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="close">Annuler</button>
          <button
            class="button is-danger"
            v-if="tagActif.name != null"
            @click="deleteTag(tagActif)"
          >
            Confirmer suppression
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data: function () {
    return {
      tags: [],
      isActiveModalUpdate: false,
      isActiveModalDelete: false,
      tagActif: [],
      tagName: null,
      is_create: false,
      id: null,
      name: null,
      error_messsage: null,
      is_failure: false,
    };
  },
  methods: {
    initializeData() {
      (this.tagName = null),
        (this.is_create = false),
        (this.id = null),
        (this.name = null),
        (this.tagActif = []),
        (this.isActiveModalUpdate = false),
        (this.error_messsage = null),
        (this.is_failure = false),
        (this.isActiveModalDelete = false);
    },
    close() {
      this.initializeData();
    },
    checkRequired() {
      if (this.name == null) {
        this.is_failure = true;
        this.error_messsage = "Veuillez renseignez un nom de tag.";
        setTimeout(() => {
          this.is_failure = false;
          this.error_messsage = null;
        }, 3000);
        return false;
      }

      return true;
    },

    //Partie ajout
    lauchCreate() {
      this.isActiveModalUpdate = true;
      this.is_create = true;
    },
    add() {
      const formData = {
        name: this.name,
      };
      axios
        .create({
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .post("tags", formData)
        .then((response) => {
          this.tags.push(response.data);
          this.initializeData();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //partie modification
    lauchUpdate(id) {
      this.is_create = false;
      this.isActiveModalUpdate = true;

      var proxy = { ...this.tags.find((x) => x.id == id) };
      const target_copy = Object.assign({}, proxy);
      (this.tagName = target_copy.name),
        (this.id = target_copy.id),
        (this.name = target_copy.name);
    },
    update(id) {
      const formData = {
        name: this.name,
      };
      axios
        .create({
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .put("tags/" + id, formData)
        .then((response) => {
          const index = this.tags.findIndex((obj) => obj.id == id);
          this.tags[index] = response.data;
          this.initializeData();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //partie suppression
    lauchDelete(id) {
      this.is_create = false;

      var proxy = { ...this.tags.find((x) => x.id == id) };
      const target_copy = Object.assign({}, proxy);
      this.tagActif = target_copy;
      this.isActiveModalDelete = true;
    },
    deleteTag(tag) {
      axios
        .create({
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .delete("tags/" + tag.id)
        .then(() => {
          const index = this.tags.indexOf(tag);
          this.tags.splice(index, 1);
          this.initializeData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    axios
      .create({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .get("tags")
      .then((response) => {
        this.tags = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
<style lang="scss"></style>
